import axios from "../../axios";
import * as actionTypes from "../actions/types";
import { openEdifySpinner, getQuotationById, openMainModal, openSuscriptionModal, closeMainModal } from "./profileActions";
import { fireAnalytics } from "../../utils/firebase";
import { getSessionId, getDeviceCategory } from "../../utils/analyticsHelpers.ts";
import { handleSubscriptionError } from "../../utils/subscriptionErrorHandler.ts";
import {
    putMaterialsQuotationAutofillDraft,
    publishMaterialsQuotationAutofillDraft,
    selectedMaterialsToAutofillMaterialLines,
    quoteFormToAutofillQuotationPatch,
} from "../../services/materialsQuotationAutofillDraftService.ts";

export const getCategoriesWithMaterials = () => async (dispatch) => {
    let authToken = localStorage.getItem("access-Token-Edify");
    let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
    try {
        const res = await axios.get('/category/all/materials', bearerToken);
        dispatch({
            type: actionTypes.GET_CATEGORIES_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: actionTypes.GET_CATEGORIES_ERROR,
            payload: err.message,
        });
    }
};

export const getCategories = () => async (dispatch) => {
    let authToken = localStorage.getItem("access-Token-Edify");
    let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

    try {
        const res = await axios.get('/category/all', bearerToken);
        dispatch({
            type: actionTypes.GET_CATEGORY_LIST,
            payload: res.data,
        });

    } catch (err) {
        dispatch({
            type: actionTypes.GET_CATEGORY_ERROR,
            payload: err.message,
        });
    }
};


export const sendQuote = (quoteData, materials, navigate) => (dispatch, getState) => {
    let authToken = localStorage.getItem("access-Token-Edify");
    let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

    dispatch({ type: actionTypes.SEND_QUOTE_REQUEST });
    dispatch(openEdifySpinner(true));
    var quotationId

    const queryParams = {
        active: 1,
        description: quoteData.description,
        name: quoteData.name,
        zone: quoteData.city,
        startDate: quoteData.receiveFrom,
        endDate: quoteData.receiveTo,
        type: "PRIVATE",
        jurisdiccion: quoteData.jurisdiccion,
        currency: quoteData.currency
    };

    let sendUrl = `/quotation/assign?description=${encodeURIComponent(queryParams.description)}&endDate=${queryParams.endDate}&active=${queryParams.active}&name=${encodeURIComponent(queryParams.name)}&startDate=${queryParams.startDate}&zone=${encodeURIComponent(queryParams.zone)}&currency=${encodeURIComponent(queryParams.currency)}&jurisdiccion=${encodeURIComponent(queryParams.jurisdiccion)}&type=${encodeURIComponent(queryParams.type)}`;

    axios.post(sendUrl, null, bearerToken)
        .then((quotationResponse) => {
            quotationId = quotationResponse.data.id;
            if (!Array.isArray(materials)) {
                throw new Error('materials no es un array');
            }

            const materialsAux = [];

            materials.forEach(material => {
                const cid =
                    material.categoryId != null && material.categoryId !== ""
                        ? Number(material.categoryId)
                        : material.category_id != null && material.category_id !== ""
                          ? Number(material.category_id)
                          : 0;
                materialsAux.push({
                    category_id: cid,
                    material_id: material.id,
                    temporary: material.temporary,
                    amount: material.quantity,
                    name: material.name,
                    unit: material.unit
                })
            });

            return axios.post('/sub_quotation/materials/crear', {
                quotation_id: quotationId,
                materials: materialsAux
            }, bearerToken);
        })
        .then((subqui) => {
            dispatch(openEdifySpinner(false));
            dispatch({ type: actionTypes.SEND_QUOTE_SUCCESS });
            
            // Evento de analytics para cotización de materiales creada
            const userData = getState().general.userData;
            fireAnalytics("material_quotation_created", {
              edify_user_id: userData?.id || "",
              session_id: getSessionId(),
              device_category: getDeviceCategory(),
              category: "publishing",
              action: "material_quotation_created",
              quotation_id: quotationId || "",
              quotation_type: "PRIVATE"
            });
            
            dispatch(
                openMainModal({
                  title: "¡Tu pedido de materiales se ha publicado correctamente!",
                  body: "Te notificaremos por correo electrónico y en la plataforma cuando los proveedores envíen un presupuesto para los materiales que has solicitado. ¡Gracias por confiar en nosotros!",
                  isSuccess: true,
                  confirmHandler: null,
                  iconType: "success",
                  noLabel: "Cerrar"
                })
              );
            setTimeout(() => {
                dispatch(getQuotationById(quotationId, false, null))
            }, 2000);
            setTimeout(() => {
                navigate(`/cotizaciondemateriales/${quotationId}`);
            }, 2000);

        })
        .catch((error) => {
            dispatch(openEdifySpinner(false));
            
            dispatch({
                type: actionTypes.SEND_QUOTE_FAIL,
                payload: error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
            });
            
            const handled = handleSubscriptionError(error, dispatch, openSuscriptionModal, openMainModal, closeMainModal);
            
            if (!handled) {
                dispatch(
                    openMainModal({
                        title: "¡Ups!",
                        body: "No hemos podido crear la solicitud, por favor inténtelo nuevamente o escribanos a contacto@edify.la ¡Muchas gracias!",
                        isSuccess: true,
                        confirmHandler: null,
                        iconType: "error",
                    })
                );
            }
            
            console.error('Error en sendQuote:', error);
        });
};

const parsePublishedQuotationIdFromAutofill = (pub) => {
    if (!pub || typeof pub !== "object") return null;
    const inner = pub.data && typeof pub.data === "object" ? pub.data : pub;
    const id = inner.id ?? inner.quotationId ?? inner.quotation_id;
    if (id == null) return null;
    const s = String(id).trim();
    return s.length ? s : null;
};

export const publishQuoteFromAutofillDraft =
    (draftId, quoteData, materials, categoryRows, navigate) => async (dispatch, getState) => {
        dispatch({ type: actionTypes.SEND_QUOTE_REQUEST });
        dispatch(openEdifySpinner(true));
        const cats = Array.isArray(categoryRows)
            ? categoryRows.map((c) => ({ id: c.id, name: c.name }))
            : [];
        try {
            const quotation = quoteFormToAutofillQuotationPatch({
                name: quoteData.name,
                city: quoteData.city,
                receiveFrom: quoteData.receiveFrom,
                receiveTo: quoteData.receiveTo,
                currency: quoteData.currency,
                description: quoteData.description,
                jurisdiccion: quoteData.jurisdiccion ? String(quoteData.jurisdiccion) : "",
                delivery: quoteData.delivery === true,
                latitude: quoteData.latitude,
                longitude: quoteData.longitude,
            });
            const materialLines = selectedMaterialsToAutofillMaterialLines(materials, cats);
            await putMaterialsQuotationAutofillDraft(draftId, { quotation, materialLines });
            const pub = await publishMaterialsQuotationAutofillDraft(draftId);
            dispatch(openEdifySpinner(false));
            dispatch({ type: actionTypes.SEND_QUOTE_SUCCESS });
            const quotationId = parsePublishedQuotationIdFromAutofill(pub);
            const userData = getState().general.userData;
            fireAnalytics("material_quotation_created", {
                edify_user_id: userData?.id || "",
                session_id: getSessionId(),
                device_category: getDeviceCategory(),
                category: "publishing",
                action: "material_quotation_created",
                quotation_id: quotationId || "",
                quotation_type: "PRIVATE",
                source: "materials_autofill_draft",
            });
            dispatch(
                openMainModal({
                    title: "¡Tu pedido de materiales se ha publicado correctamente!",
                    body: "Te notificaremos por correo electrónico y en la plataforma cuando los proveedores envíen un presupuesto para los materiales que has solicitado. ¡Gracias por confiar en nosotros!",
                    isSuccess: true,
                    confirmHandler: null,
                    iconType: "success",
                    noLabel: "Cerrar",
                })
            );
            if (quotationId) {
                setTimeout(() => {
                    dispatch(getQuotationById(quotationId, false, null));
                }, 2000);
                setTimeout(() => {
                    navigate(`/cotizaciondemateriales/${quotationId}`);
                }, 2000);
            }
        } catch (error) {
            dispatch(openEdifySpinner(false));
            dispatch({
                type: actionTypes.SEND_QUOTE_FAIL,
                payload:
                    error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : error.message,
            });
            const handled = handleSubscriptionError(error, dispatch, openSuscriptionModal, openMainModal, closeMainModal);
            if (!handled) {
                dispatch(
                    openMainModal({
                        title: "¡Ups!",
                        body: "No hemos podido publicar la solicitud. Revisá los datos o intentá de nuevo. Si el problema continúa, escribinos a contacto@edify.la",
                        isSuccess: true,
                        confirmHandler: null,
                        iconType: "error",
                    })
                );
            }
            console.error("Error en publishQuoteFromAutofillDraft:", error);
        }
    };

export const getAllMaterialsCatalogFile = () => async (dispatch) => {
    let authToken = localStorage.getItem("access-Token-Edify");
    let bearerToken = { 
        headers: { Authorization: `Bearer ${authToken}` },
        responseType: 'blob' 
    };

    try {
        dispatch(openEdifySpinner(true));
        const res = await axios.get('/materials/catalog/export', bearerToken);

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'catalogo.pdf'); 
        document.body.appendChild(link);
        link.click();


        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        dispatch(openEdifySpinner(false));
        dispatch(
            openMainModal({
                title: "¡Descarga exitosa!",
                body: "El archivo se ha descargado correctamente",
                iconType: "success",
                isSuccess: true,
                confirmHandler: null,
            })
        );

    } catch (err) {
        dispatch(openEdifySpinner(false));
        dispatch(
            openMainModal({
                title: "¡Ups!",
                body: "No hemos podido descargar el archivo, por favor inténtelo nuevamente o escribanos a contacto@edify.la ¡Muchas gracias!",
                isSuccess: true,
                iconType: "error",
                confirmHandler: null,
            })
        );  
    }
};


export const resetSuccess = () => ({
    type: actionTypes.RESET_SUCCESS,
});

